import { Flex, Text } from '@chakra-ui/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TextWithIcon: React.FC<{ icon: IconProp; text?: string }> = ({
  icon,
  text
}) => (
  <Flex gap={2} textStyle="textContext" alignItems="center">
    <FontAwesomeIcon icon={icon} />
    <Text>{text}</Text>
  </Flex>
);

export default TextWithIcon;
